import PackageProvider from 'components/Orders/package/packageProvider';
import ShippingProvider from 'components/Orders/package/shippingProvider';
import React from 'react';

import CreatePackage from './createPackage';

export default function CreatePackagePage() {
  return (
    <ShippingProvider>
      <PackageProvider>
        <CreatePackage />
      </PackageProvider>
    </ShippingProvider>
  );
}
